var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProdutosAtivoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7111 14.0593C23.8024 14.0202 23.9007 14 24 14C24.0993 14 24.1976 14.0202 24.2889 14.0593L33.8378 18.1523C33.9994 18.2216 33.9994 18.4507 33.8378 18.5199L24.0788 22.7024C24.0285 22.7239 23.9715 22.7239 23.9212 22.7024L14.1622 18.5199C14.0006 18.4507 14.0006 18.2216 14.1622 18.1523L23.7111 14.0593ZM13.2788 19.7375C13.1468 19.6809 13 19.7777 13 19.9213V30.8673C13 31.1607 13.176 31.4247 13.4444 31.542L22.9879 35.6318C23.1199 35.6884 23.2667 35.5916 23.2667 35.448V24.1499C23.2667 24.0699 23.219 23.9976 23.1455 23.966L13.2788 19.7375ZM24.7333 24.1499C24.7333 24.0699 24.781 23.9976 24.8545 23.966L34.7212 19.7375C34.8532 19.6809 35 19.7777 35 19.9213V30.8673C35.0001 31.0109 34.9581 31.1514 34.8791 31.2714C34.8001 31.3913 34.6876 31.4854 34.5556 31.542L25.0121 35.6318C24.8801 35.6884 24.7333 35.5916 24.7333 35.448V24.1499Z",
    fill: "#4D78AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProdutosAtivoB);
export default __webpack_public_path__ + "static/media/IconProdutosAtivoB.cdc8598bd83fbb9bb21fc9e96973c772.svg";
export { ForwardRef as ReactComponent };